<svelte:options customElement="hb-input-checkbox" />

<script lang="ts">
  /**
   * Svelte Input Checkbox WebComponent
   * =====================
   *
   * @contributors: Dario Caruso <dev@dariocaruso.info> (https://dariocaruso.info)
   *
   * @license: MIT License
   *
   */

  import type { FormSchemaEntry, Component } from "./types/webcomponent.type";

  function dispatch(name: string, detail: any) {
    $host().dispatchEvent(new CustomEvent(name, { detail }));
  }
  let {
    schemaentry, // Rinomina per evitare conflitti con la versione elaborata

    show_validation = "no", // Default a "no"
    id = undefined, // Default a undefined
  }: Component = $props();

  let valid = $derived.by(() => {
    if (schemaentry.required) {
      if (value) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  });
  let value: boolean | undefined = $state(false);

  $effect(() => {
    if (!show_validation) show_validation = "no";
    if (schemaentry && typeof schemaentry === "string") {
      try {
        schemaentry = JSON.parse(schemaentry as unknown as string);

        value = schemaentry.value as boolean;
        if (!id && schemaentry?.id) {
          id = schemaentry.id;
        }
      } catch (err) {}
    }

    console.log("effectinputcheckbox", valid, value, schemaentry);

    // });
    // $effect(() => {
    // if (set_value) dispatch("setVal", { value, id: id });
  });
  // setTimeout(() => {
  //   if (set_value) dispatch("setVal", { value, id: id });
  // }, 0);
  $effect(() => {
    dispatch("setVal", { value, valid, id: id });
  });
</script>

<div
  class="form-check {typeof schemaentry === 'object' &&
  schemaentry?.params?.type === 'switch'
    ? 'form-switch'
    : ''}"
>
  {#if schemaentry}
    {#if typeof schemaentry === "object" && schemaentry?.params?.type === "switch"}
      <input
        bind:checked={value}
        type="checkbox"
        class="form-check-input"
        {id}
        required={schemaentry?.required}
        readonly={schemaentry?.readonly}
        switch
      />
    {:else}
      <input
        bind:checked={value}
        type="checkbox"
        class="form-check-input"
        {id}
        required={schemaentry?.required}
        readonly={schemaentry?.readonly}
      />
    {/if}
    <label for={schemaentry?.id} class="form-check-label"
      >{schemaentry?.label}{schemaentry?.required ? "*" : ""}</label
    >
  {/if}
</div>
{#if schemaentry?.validationTip && show_validation === "yes"}
  <div part="invalid-feedback" class="invalid-feedback mb-1">
    {schemaentry.validationTip}
  </div>
{/if}

<style lang="scss">
  @forward "./styles/bootstrap.scss";
  @forward "./styles/webcomponent.scss";
</style>
